module.exports = "/packs/images/svg/facilities/sports~d77b9b4d1af08b9fc8df23eb6a82fd1e.svg";